import useRollbar from "./useRollbar";

export default useRollbar;
